<template>
    <div class="timeconfig-detail">
        <el-form ref="timeconfigForm" :rules="rules" :model="timeconfig" size="mini" label-width="120px" class="timeconfig-form">
            <el-row v-if="!isInstance">
              <el-col :span="12">
                <el-form-item label="模板名称" prop="templateName">
                  <el-input :readonly="isInstance" v-model="timeconfig.templateName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="流程方案" prop="processServiceId">
                    <!-- <el-input v-model="timeconfig.processServiceName"></el-input>
                     -->
                    <el-select :disabled="timeconfig.id!='' || isInstance" v-model="timeconfig.processServiceId"  @change="_initServiceTimeTreeList" placeholder="请选择">
                        <el-option
                        v-for="item in processTemplateList"
                        :key="item.id"
                        :label="item.processServiceName+'【'+item.definitionName+'(V'+item.version+')'+'】'"
                        :value="item.processServiceId">
                        </el-option>
                    </el-select>
                     <el-button v-if="timeconfig.processServiceId!==''" style="margin-left:2px;" title='预览流程模板' icon="el-icon-view" circle @click="handleNavViewDetail()"></el-button>
                </el-form-item>
              </el-col>
            </el-row>
           <el-row>
                <el-col :span="6">
                    <el-form-item label="总计划时长(天)" prop="planTotalDays">
                       <el-tooltip  content="总计划时长默认等于任务列表里的所有任务工作时长累积的值" effect="light" placement="top">
                          <el-input :readonly="isInstance" type="number" placeholder="" v-model="timeconfig.planTotalDays"></el-input>
                       </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col v-if="isInstance" :span="6">
                 <el-form-item label="最终完成时间" prop="planFinalEndTime">
                      <el-date-picker
                          :readonly="isInstance"
                          v-model="timeconfig.planFinalEndTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :editable="true"
                          placeholder="选择日期时间"
                      >
                      </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="" >
                      <!-- <el-button v-if="isInstance && ifConfigTask"  style="margin-left:15px;float: right" type="primary" size="mini" @click="handleTimeconfigFormSave">保存配置</el-button> -->
                      <el-button v-if="isInstance && !isFullScreen"  style="margin-left:15px;float: right" class='print-class'  type="primary" icon="el-icon-rank"  size="mini" @click.stop="handleFullScreen()">全屏</el-button>
                      <el-button v-if="isInstance" style="margin-left:15px;float: right" title='表单库' type="primary" icon="el-icon-goods" circle @click="handleTimeTemplateForms()"></el-button>
                      <el-button v-if="isInstance" style="margin-left:15px;float: right" title='导出' type="primary" icon="el-icon-download" circle @click="exportTimeConfigDetailToExcel()"></el-button>
                      <el-button v-if="isInstance" style="margin-left:15px;float: right" title='预览流程模板' icon="el-icon-view" circle @click="handleNavViewDetail()"></el-button>
                      <el-button v-if="isInstance" style="margin-left:15px;float: right" title='查看甘特图' icon="el-icon-s-data" circle @click="handleNavViewTimeGantt()"></el-button>
                      <el-button v-if="isInstance && ifConfigTask" style="margin-left:15px;float: right" title='根据第一个任务的开始时间及各任务的工作时长，自动计算后续任务的时间' type="primary" icon="el-icon-time" circle @click="handleCalculateTime()"></el-button>
                      <!-- <el-tooltip content="点击切换：展开/收起 所有的子任务节点" placement="top"> -->
                          <el-switch
                            v-if="isInstance"
                            style="margin-left:15px;margin-top: 4px;float: right"
                            v-model="expandAll"
                            active-text=""
                            inactive-text=""
                            title="点击切换：展开/收起 所有的子任务节点"
                            @change="changeSwitch"
                          >
                          </el-switch>
                      <!-- </el-tooltip> -->
                    </el-form-item>
                </el-col>
             </el-row>
             <el-row v-if="!isInstance" >
                <el-col :span="12">
                  <el-form-item label="模板描述" prop="remarks">
                      <el-input v-model="timeconfig.remarks" style="width:101%;overflow-x:hidden;"  type="textarea" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                    <DataOperateEdit ref="dataOperate" :isApproval="isTimeConfig" :isTimeConfig="isTimeConfig" :dataOperate='dataOperate'/>
                </el-col>
             </el-row>
             <el-row v-if="!isInstance" >
                <el-col :span="12">
                    <el-switch
                        style="margin-left: 8%;margin-top: -4%;"
                        v-model="expandAll"
                        active-text=""
                        inactive-text=""
                        title="点击切换：展开/收起 所有的子任务节点"
                        @change="changeSwitch"
                      >
                      </el-switch>
                </el-col>
             </el-row>
            <!-- <el-collapse class="process-detail-Forms" v-model="collapseActiveName"  v-if="isShowDiagram" accordion>
              <el-collapse-item title="流程模板" name="1">
                  <ProcessDetailView ref="detailView" :viewParams="viewParams"/>
                </el-collapse-item>
            </el-collapse> -->
            <!-- <TreeTableExt height="340px" :data="taskTimeTreeList" :isShowBtn="isShowBtn" :isShowCheckbox="false" :expandAll="true" :columns="taskTimeTreeColumns" border/> -->
         <TreeTableDrag ref="treeTableDragRef" :key="loadTimer"  :isdraggable="true" :treeColumns="treeColumns" :treeDatas="treeDatas" :tableHeight="tableHeight" @treeDataChange="treeDataChange"></TreeTableDrag>
        </el-form>
         <!-- 显示详细 -->
        <el-dialog
            title="流程明细"
            :fullscreen=true
            append-to-body
            :visible.sync="isShowDiagram"
            custom-class="diagram-dialog">
            <ProcessDetailView ref="detailView" :viewParams="viewParams" />
        </el-dialog>
         <el-dialog
              title="任务配置"
              :visible.sync="isShowTaskTimeDialog"
              top="4vh"
              width="50%"
              append-to-body
              >
              <el-form :model="configDetailObj" ref="configDetailObjForm" size="mini" label-width="120px">
                 <el-row >
                      <el-form-item label="任务类型">
                         <el-tag  v-if="configDetailObj.pId && configDetailObj.pId!==0" type="info">子任务</el-tag>
                         <el-tag v-else type="success">主任务</el-tag>
                      </el-form-item>
                  </el-row>
                  <el-row >
                      <el-form-item label="任务节点">
                         <template v-if="configDetailObj.pId && configDetailObj.pId!==0" >
                           <el-input style="width:38%" disabled v-model="configDetailObj.pLabel"></el-input>
                         </template>
                        <template v-else>
                            <el-input  style="width:38%" disabled v-model="configDetailObj.label"></el-input>
                        </template>

                      </el-form-item>
                  </el-row>
                  <el-row v-if="configDetailObj.pId && configDetailObj.pId!==0">
                      <el-form-item
                         prop="label"
                         label="子任务名称"
                         :rules="[
                            { required: true, message: '请输入子任务名称', trigger: 'change' }
                          ]"
                      >
                        <el-input style="width:38%" v-model="configDetailObj.label"></el-input>
                      </el-form-item>
                  </el-row>
                  <el-row>
                        <el-form-item  label="工作时长(天)"
                         prop="workingDays"
                         :rules="[
                            { required: true, message: '请输入子任务名称', trigger: 'change' }
                          ]">
                           <el-input-number v-model="configDetailObj.workingDays" :min="0" :max="99999"></el-input-number>
                           <!-- <el-input type="number" placeholder="" v-model="configDetailObj.workingDays"></el-input> -->
                        </el-form-item>
                  </el-row>
                  <el-row v-if="isInstance" ><!-- 项目模板设置时从任务配置信息处带过来 -->
                      <el-form-item label="任务负责人">
                          <template  v-if="configDetailObj.pId && configDetailObj.pId!==0" >
                              <el-input v-if="this.ifConfigTask" style="width:38%"  readonly v-model="selectedUser.selectedUserNames" @focus="chooseUser" ></el-input>
                              <el-input  v-else style="width:38%"  disabled v-model="selectedUser.selectedUserNames" ></el-input>
                          </template>
                           <template v-else >
                                <el-input   style="width:38%"  disabled v-model="selectedUser.selectedUserNames" ></el-input>
                              <template v-if="configDetailObj.taskStatus!==2 && instancesInfo.canInterveneProcess" >
                                <el-tooltip  content="当前任务节点为主任务，请使用【流程任务干预】功能修改主任务的负责人" effect="light" placement="top">
                                   <el-button  type="primary" size="mini" icon="el-icon-warning" title="流程任务干预" circle @click="handelSetMainTask()"></el-button>
                                </el-tooltip>
                              </template>
                          </template>
                          <UserOrgPop  :multiple="false" :isShowUserOrg='isShowUserOrg'  :selectedUser="selectedUser" ref="userOrgPop" @nodeClick="selectTrigger"  />
                      </el-form-item>
                  </el-row>

                  <el-row  v-if="isInstance" >
                      <el-form-item label="计划开始时间">
                        <el-date-picker
                         :readonly="!isInstance"
                          v-model="configDetailObj.planStartTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :editable="true"
                          :clearable="true"
                        />
                      </el-form-item>
                  </el-row>
                   <el-row  v-if="isInstance" >
                        <el-form-item label="计划结束时间">
                           <el-date-picker
                            :readonly="!isInstance"
                            v-model="configDetailObj.planEndTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :editable="true"
                            :clearable="true"
                          />
                        </el-form-item>
                    </el-row>
                    <el-row  v-if="isInstance"  >
                        <el-form-item label="任务提醒时间">
                           <el-date-picker
                            :readonly="!isInstance"
                            v-model="configDetailObj.warningTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :editable="true"
                            :clearable="true"
                            default-time="12:00:00"
                          />
                        </el-form-item>
                    </el-row>

                    <el-row   v-if="isInstance" style="margin-top:4%">
                        <el-form-item  label="实际进度">
                          <ProcessSlider :key="loadTimer" ref="processSliderRef" :min=0 :max=100 :value="configDetailObj.processVal" v-model="configDetailObj.processVal"></ProcessSlider>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item  label="任务描述">
                           <el-input v-model="configDetailObj.taskNodeDes" style="width:90%;overflow-x:hidden;"  type="textarea" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                        </el-form-item>
                    </el-row>
              </el-form>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowTaskTimeDialog = false">取 消</el-button>
                  <el-button v-if="this.ifConfigTask || (this.configDetailObj.pId && this.configDetailObj.pId !== 0 && this.configDetailObj.assigneeId === this.loginUserId)" type="primary" :loading="!isShowTaskTimeDialog" @click="handleSaveConfigDetail(false)">保存</el-button>
              </span>
          </el-dialog>
          <!-- <el-dialog
            title="时间甘特图"
            :fullscreen=true
            append-to-body
            :key="loadTimer"
            :visible.sync="isShowTimeGantt"
            custom-class="diagram-dialog">
            <TimeGantt ref="timeGannt" :isHideMenu = "true" /> 
        </el-dialog> -->
        <el-dialog
            title="时间甘特图"
            :fullscreen=true
            append-to-body
            :key="loadTimer"
            :visible.sync="isShowTimeGantt"
            custom-class="diagram-dialog">
            <TimeConfigGantt ref="timeConfigGantt" />
        </el-dialog>

        <div>
        <el-dialog
              custom-class="task-edit-dialog"
              :title="taskTile"
              :visible.sync="isShowEleEditor"
              top="2vh"
              width="88%"
              :fullscreen="true"
              append-to-body
              >
              <!-- 用户任务 节点 -->
              <ElementEditor :key="loadTimer" :taskData="taskData" :processInstance="instancesInfo" @hideMainSaveBtn="hideMainSaveBtn"/>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowEleEditor = false">取 消</el-button>
                  <el-button v-if="isShowSaveBtn" type="primary" :loading="!isShowEleEditor" @click="handleSaveConfig">保存配置</el-button>
              </span>
          </el-dialog>
          <el-dialog
              custom-class="task-edit-dialog"
              :title="taskTile"
              :visible.sync="isShowTimeTemplateInstanceFormsDialog"
              top="2vh"
              width="88%"
              :fullscreen="true"
              append-to-body
              >
              <TimeTemplateInstanceForms :key="loadTimer" :timeTemplateInstanceId="timeTemplateInstanceId"/>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowTimeTemplateInstanceFormsDialog = false">取 消</el-button>
              </span>
          </el-dialog>
        </div>
    </div>
</template>

<script>
    import { interveneProcessTaskConfig, getProcessServiceInstanceConfig, getPlanTimeGantt, saveServiceTimeTemplate, saveServiceTimeTemplateInstance, deleteServiceTimeTreeNode, deleteServiceTimeInstanceTreeNode, getProcessTemplateList, getServiceTimeTreeList, getServiceTimeTemplate, getServiceTimeTemplateInstance, getServiceTimeTreeInstanceList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import { cloneDeep, isEmpty, defaultsDeep } from 'lodash';
    // import TreeTableExt from '@/components/TreeTableExt';
    import TreeTableDrag from '@/components/TreeTableDrag';
    import ProcessSlider from '@/components/ProcessSlider';
    import { API_PROCESS_TIME_CONFIG_DETAIL_TO_EXCEL } from '@/common/constants';
    import ProcessDetailView from '@/pages/process/ProcessList/ProcessDetailView';
    import { defaultElementData } from '@/pages/process/MyProcess/defaultData';
    import ElementEditor from '@/pages/process/ProcessEditor/components/ElementEditor';
    // import TimeGantt from '@/pages/operation/TimeGantt';
    import TimeConfigGantt from '@/pages/process/TimeConfig/TimeConfigGantt/TimeConfigGantt';
    import DataOperateEdit from '@/pages/process/ProcessEditor/components/DataOperateEdit';
    import TimeTemplateInstanceForms from './TimeTemplateInstanceForms';
    import { dateFormat } from '@/utils/date.js';

    export default {
        components: {
            TreeTableDrag,
            ProcessSlider,
            ProcessDetailView,
            // TimeGantt,
            TimeConfigGantt,
            ElementEditor,
            DataOperateEdit,
            TimeTemplateInstanceForms
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                timeTemplateInstanceId: '',
                isShowTimeTemplateInstanceFormsDialog: false,
                dataOperate: {forms: [], dataSource: 2},
                isTimeConfig: true,
                taskData: {},
                taskTile: '',
                loadTimer: '',
                isShowSaveBtn: true,
                isShowEleEditor: false,
             	  isShowTimeGantt: false,
                expandAll: false,
                collapseActiveName: '1',
                isShowDiagram: false,
                viewParams: {},
                isShowBtn: false,
                isShowTreeTable: false,
                processTemplateList: [],
                selectedProcess: {},
                isShowTaskTimeDialog: false,
                configDetailObj: {
                    label: '',
                    assigneeId: '',
                    assigneeName: '',
                    planStartTime: '',
                    planEndTime: '',
                    warningTime: '',
                    workingDays: 0,
                    processVal: 0,
                    taskStatus: null,
                    taskInstanceId: null
                },
                treeColumns: [
                    // {
                    //     type: 'checkbox',
                    //     isContainChildren: true, // 是否勾选子节点，默认false
                    //     onChange: this.onCheck, // parmas selectRows
                    //     // title: '链接',
                    //     // field: 'url',
                    //     width: 50,
                    //     align: 'center'
                    // },
                    // {
                    //     title: '序号',
                    //     field: 'viewOrder',
                    //     width: 50,
                    //     align: 'center'
                    // },
                    // {
                    //     type: 'selection',
                    //     title: '任务节点',
                    //     field: 'label',
                    //     width: 200,
                    //     align: 'center',
                    //     formatter: (item) => {
                    //         return '<a>' + item.label + '</a>';
                    //         // return "<div id='" + item.id + "' onmouseover=\"alert('\"'" + item.label + '")">' + item.label + '</div>';
                    //         // return "<a onmouseover=\"alert('" + item.label + "')\">" + item.label + '</a>';
                    //         // return "<el-popover placement='top-start' width='200' trigger='hover' content='" + item.label + "'> <el-button slot='reference'>" + item.label + '</el-button></el-popover>';
                    //         // return "<span><button type='button' class='el-button el-button--default el-popover__reference' aria-describedby='el-popover-7884' tabindex='0'><span>" + item.label + '</span></button></span>';
                    //     }
                    // },
                    {
                        title: '任务顺序',
                        type: 'selection',
                        field: 'viewOrder',
                        width: 80,
                        align: 'center'
                    },
                    {
                        type: 'action',
                        title: '任务节点',
                        field: 'label',
                        width: 185,
                        align: 'center',

                        actions: [
                            {
                                text: '',
                                onclick: this.onEdit,
                                formatter: (item) => {
                                    return '<a  style="cursor:pointer;">' + item.label + '</a>';
                                }
                            }
                        ]
                    },
                    {
                        title: '任务描述',
                        field: 'taskNodeDes',
                        width: 100,
                        align: 'center'
                    },
                    {
                        title: '状态',
                        field: 'taskStatus',
                        width: 100,
                        align: 'center',
                        formatter: (item) => {
                            let status = '未开始';
                            if (item.taskStatus === 1) {
                                status = '进行中';
                            } else if (item.taskStatus === 2) {
                                status = '已完成';
                            } else if (item.taskStatus === 4) {
                                status = '待认领';
                            } else if (item.taskStatus === 5) {
                                status = '已延期';
                            } else if (item.taskStatus === 6) {
                                status = '快到期';
                            }
                            return status;
                        }
                    }
                    // {
                    //     title: '计划开始时间',
                    //     field: 'planStartTime',
                    //     width: 170,
                    //     align: 'center'
                    // },
                    // {
                    //     title: '计划结束时间',
                    //     field: 'planEndTime',
                    //     width: 170,
                    //     align: 'center'
                    // },
                    // {
                    //     title: '任务提醒时间',
                    //     field: 'warningTime',
                    //     width: 170,
                    //     align: 'center'
                    // },
                    // {
                    //     title: '工作时长(天)',
                    //     field: 'workingDays',
                    //     width: 120,
                    //     align: 'center'
                    // }
                    // ,
                    // {
                    //     title: '任务进度',
                    //     field: 'processVal',
                    //     width: 120,
                    //     align: 'center'
                    //     // formatter: (item) => {
                    //     //     return '<div role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" class="el-progress el-progress--line"><div class="el-progress-bar"><div class="el-progress-bar__outer" style="height: 6px;"><div class="el-progress-bar__inner" style="width: 50%;"><!----></div></div></div><div class="el-progress__text" style="font-size: 14.4px;">50%</div></div>';
                    //     // }
                    // },
                    // {
                    //     title: '操作',
                    //     type: 'action',
                    //     width: 150,
                    //     align: 'center',
                    //     actions: [
                    //         {
                    //             text: '配置',
                    //             onclick: this.onEdit,
                    //             formatter: (item) => {
                    //                 // return '<i>编辑</i>';
                    //                 return "<button type='button' class='el-button el-button--primary el-button--mini is-circle' title='配置'><!----><i class='el-icon-setting'></i><!----></button>";
                    //             }
                    //         }
                    //     ]
                    // }
                ],
                taskProcessVal: {
                    title: '任务进度',
                    field: 'processVal',
                    width: 120,
                    align: 'center',
                    formatter: (item) => {
                        // console.log(item);
                        if (item.processVal) {
                            return item.processVal + '%';
                        }
                        // else {
                        //     return '';
                        // }
                    }
                },
                taskConfigBtn: {
                    // title: '操作',
                    title: '',
                    type: 'action',
                    width: 120,
                    align: 'center',
                    actions: [
                        {
                            text: '',
                            onclick: this.addSubTask,
                            formatter: (item) => {
                                return "<button type='button' class='el-button el-button--primary el-button--mini is-circle' title='加子任务'><!----><i class='el-icon-plus'></i><!----></button>";
                            }
                        },
                        {
                            text: '',
                            onclick: this.deleteSubTask,
                            formatter: (item) => {
                                if (item.pId !== 0) {
                                    return "<button style='margin-left:5px' type='button' class='el-button el-button--danger el-button--mini is-circle' title='删除子任务'><!----><i class='el-icon-delete'></i><!----></button>";
                                }
                            }
                        }
                    ]
                },
                taskTimeArr: [
                    {
                        title: '计划开始时间',
                        field: 'planStartTime',
                        width: 120,
                        align: 'center'
                    },
                    {
                        title: '计划结束时间',
                        field: 'planEndTime',
                        width: 120,
                        align: 'center'
                    }
                ],
                taskWarningTime: {
                    title: '任务提醒时间',
                    field: 'warningTime',
                    width: 160,
                    align: 'center'
                },
                taskWorkingDays: {
                    title: '工作时长(天)',
                    field: 'workingDays',
                    width: 90,
                    align: 'center'
                },
                assigneeName: {
                    title: '负责人',
                    field: 'assigneeName',
                    width: 60,
                    align: 'center'
                },
                treeDatas: [],
                timeconfig: {
                    id: '',
                    templateId: '',
                    templateName: '',
                    processServiceId: '',
                    processServiceName: '',
                    deploymentId: '',
                    planTotalDays: 0,
                    planFinalEndTime: '',
                    remarks: ''
                },
                taskSumTotalDays: 0,
                rules: {
                    templateName: [
                        { required: true, message: '请输入模板名称名', trigger: 'change' },
                        { min: 2, max: 200, message: '长度在 2 到 200 个字符', trigger: 'change' }
                    ],
                    processServiceId: [
                        { required: true, message: '请选择流程方案', trigger: 'change' }
                    ],
                    planTotalDays: [
                        { required: true, message: '请输入总计划时长', trigger: 'change' }
                    ]
                },
                isShowUserOrg: false,
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                currentPItem: {},
                oldConfigDetailObj: {},
                loginUserId: ''
            };
        },
        props: {
            timeConfigObj: {
                type: Object
            },
            isInstance: {
                type: Boolean,
                default: false
            },
            instancesInfo: {
                type: Object
            },
            tableHeight: {
                type: Number,
                default: 280
            },
            ifConfigTask: {
                type: Boolean,
                default: false
            },
            isFullScreen: { // 是否全屏
                type: Boolean,
                default: true
            }
        },
        created () {
            // this._initProcessTemplateList();
            // this._initPage();
            this.isShowSaveBtn = true;
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                this.loginUserId = currentUserInfo.userId;
            }
        },
        methods: {
            async _initPage (obj) {
                // console.log(obj);
                if (obj) {
                    this.dataOperate = obj.dataOperate;
                }
                this.treeColumns.push(this.assigneeName);
                if (this.isInstance) {
                    this.taskTimeArr.forEach(element => {
                        this.treeColumns.push(element);
                    });
                    // this.treeColumns = this.treeColumns.concat(this.taskTimeArr);
                    this.treeColumns.push(this.taskWarningTime);
                    // if (this.isFullScreen) { // 全屏时显示
                    this.treeColumns.push(this.taskProcessVal);
                    // }
                }
                this.treeColumns.push(this.taskWorkingDays);
                if (this.ifConfigTask) {
                    this.treeColumns.push(this.taskConfigBtn);
                }
                if (!this.isInstance) {
                    await this._initProcessTemplateList();
                }
                if (this.isInstance) {
                    let dataInstance = await getServiceTimeTemplateInstance(this.instancesInfo.id);
                    // let dataInstance = await getServiceTimeTemplate(obj.id);
                    // console.log(dataInstance);
                    this.timeconfig = dataInstance;
                } else {
                    this.timeconfig = obj;
                }
                if (this.timeconfig.id) {
                    await this._initServiceTimeTreeList(this.timeconfig.processServiceId);
                } else {
                    this.treeDatas = [];
                    setTimeout(() => {
                        this.$refs.treeTableDragRef._resetData(this.treeDatas);
                    }, 0);
                }
                this.initTotalDays();
                this.expandAll = true;
                this.changeSwitch();
            },
            async _initServiceTimeTreeList (id) {
                let selectedItem = {};
                for (let item of this.processTemplateList) {
                    if (id === item.processServiceId) {
                        selectedItem = item;
                        break;
                    }
                }
                if (selectedItem.processServiceId) {
                    this.selectedProcess = selectedItem;
                    this.timeconfig.processServiceId = selectedItem.processServiceId;
                    this.timeconfig.deploymentId = selectedItem.deploymentId;
                    this.timeconfig.processDefinitionId = selectedItem.id;
                }
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let treeList = [];
                if (this.isInstance) {
                    treeList = await getServiceTimeTreeInstanceList({processInstanceId: this.instancesInfo.id, templateId: this.timeconfig.templateId});
                } else {
                    treeList = await getServiceTimeTreeList({templateId: this.timeconfig.id, processServiceId: this.timeconfig.processServiceId, processDefinitionId: this.timeconfig.processDefinitionId, deploymentId: this.timeconfig.deploymentId});
                }

                this.treeDatas = treeList;
                await this.$refs.treeTableDragRef._resetData(this.treeDatas);
                loading.close();
                this.isShowDiagram = false;
            },
            async _initProcessTemplateList () {
                let { data } = await getProcessTemplateList({ state: 3, currentPage: 0, pageSize: 500 });// 查出所有版本的流程方案
                this.processTemplateList = data;
            },
            handleNavViewDetail () {
                // console.log(this.isInstance);
                if (this.isInstance) {
                    this.viewParams.id = this.instancesInfo.processDefinitionIdExt;
                } else {
                    // console.log(this.selectedProcess);
                    this.viewParams.id = this.selectedProcess.processDefinitionId;
                }
                this.viewParams.pModelId = '';
                this.viewParams.viewDiagram = true;
                this.isShowDiagram = true;
                // console.log(this.viewParams);
                setTimeout(() => {
                    this.$refs.detailView.setProcessState(this.viewParams);
                }, 0);
            },
            async handleTimeconfigFormSave () {
                let result = true;
                // setTimeout(() => {
                await this.$refs.treeTableDragRef._submitData(this.treeDatas);
                // }, 0);
                this.$refs['timeconfigForm'].validate(async (valid) => {
                    if (valid) {
                        if (this.timeconfig.planTotalDays !== this.taskSumTotalDays) {
                            this.$confirm(`总计划时长与任务列表里的所有任务时长累积时间不一致，您确定要继续保存模板吗？`, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(async (res) => {
                                this.saveData();
                            }).catch(() => {
                                result = false;
                            });
                        } else {
                            this.saveData();
                        }
                    } else {
                        result = false;
                    }
                });
                // this.$emit('hideFullScreenDialogForTime');
                return result;
            },
            async saveData () {
                this.timeconfig.treeDatas = this.$refs.treeTableDragRef.getCurrentTreeData();
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if (this.isInstance) {
                    this.timeconfig.processInstanceId = this.instancesInfo.id;
                    await saveServiceTimeTemplateInstance(this.timeconfig);
                    this.$emit('initTimeConig');
                } else {
                    await saveServiceTimeTemplate(this.timeconfig);
                    this.$emit('handleSearch');
                }
                loading.close();
            },
            handleCancel () {
                if (this.timeconfigInfo) {
                    // setTimeout(() => {
                    //     this.$emit('hideSidebox');
                    // }, 100);
                } else {
                    // this.navCronjobList();
                }
            },
            onEdit (item) {
                this.initForm();
                this.oldConfigDetailObj = cloneDeep(item);
                this.configDetailObj = item;
                if (!this.configDetailObj.workingDays) {
                    this.configDetailObj.workingDays = 0;
                }
                this.selectedUser.selectedUserIds = item.assigneeId;
                this.selectedUser.selectedUserNames = item.assigneeName;
                if (!item.hasOwnProperty('processVal') || !item.processVal) {
                    this.configDetailObj.processVal = 0;
                }
                this.loadTimer = new Date().getTime();
                this.isShowTaskTimeDialog = true;
            },
            async deleteSubTask (item) {
                this.$confirm('您确定要删除子任务【' + item.label + '】吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let treeDatas = this.$refs.treeTableDragRef.getCurrentTreeData();
                    for (var i = 0; i < treeDatas.length; i++) {
                        if (treeDatas[i].id === item.id) {
                            treeDatas.splice(i, 1);
                        } else if (treeDatas[i].children) {
                            this.deleteChildrenItem(treeDatas[i].children, item.id);
                        }
                    }
                    // this.loadTimer = new Date().getTime();
                    if (this.isInstance) {
                        this.isRefresh = false;
                    } else {
                        this.expandAll = true;
                    }
                    if (this.isInstance) {
                        await deleteServiceTimeInstanceTreeNode(item.id, this.instancesInfo.id);
                    } else {
                        await deleteServiceTimeTreeNode(item.id);
                    }
                    // await this.handleSaveConfigDetail(false);
                });
            },
            deleteChildrenItem (arr, id) {
                let innerOrder = 0;
                arr.forEach((v, i) => {
                    v.open = true;
                    if (v.id === id) {
                        arr.splice(innerOrder, 1);
                    }
                    if (v.children) {
                        this.deleteChildrenItem(v.children, id);
                    }
                    innerOrder++;
                });
            },
            addSubTask (item) {
                this.initForm();
                // this.configDetailObj = cloneDeep(item);
                this.configDetailObj.label = '';
                this.configDetailObj.workingDays = 0;
                this.configDetailObj.pId = item.id;
                this.configDetailObj.pLabel = item.label;
                this.configDetailObj.isAddSubTask = true;
                this.currentPItem = item;
                this.configDetailObj.viewOrder = 0;
                this.configDetailObj.id = this.getRandomNumber();
                this.configDetailObj.isNew = true;
                this.configDetailObj.opMode = 0;
                // console.log(this.configDetailObj.id);
                if (!item.hasOwnProperty('processVal') || !item.processVal) {
                    this.configDetailObj.processVal = 0;
                }
                this.loadTimer = new Date().getTime();
                this.isShowTaskTimeDialog = true;
            },
            getRandomNumber () {
                return Number((new Date().getTime()).toString().substr(4, 13));
            },
            initForm () {
                this.configDetailObj = {
                    label: '',
                    assigneeId: '',
                    assigneeName: '',
                    planStartTime: '',
                    planEndTime: '',
                    warningTime: '',
                    workingDays: 0,
                    processVal: 0,
                    pId: 0
                };
                this.selectedUser = {
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
                this.currentPItem = {};
                this.oldConfigDetailObj = {};
            },
            handleCalculateTime () {
                this.$confirm(`请选择时间批量设置模式。【级联】：根据第一个任务时间开始结合任务的工作时长计算后级联自动替换后续任务的计划开始时间。【非级联】：假如任务没有计划开始时间则根据系统自动生成，假如有则使用已有的时间进行计算`, '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '级联',
                    cancelButtonText: '非级联',
                    type: 'warning'
                }).then(() => {
                    this.handleSaveConfigDetail(true, false);
                }).catch((action) => {
                    if (action === 'cancel') { // 判断是 cancel (非级联) 还是 close （关闭弹窗）
                        this.handleSaveConfigDetail(true, true);
                    }
                });
            },
            async handleSaveConfigDetail (isRefresh, isNotCascade) { // isForce是否强制替换计划开始时间
                // this.timeconfig.planTotalDays = 0;
                if (isRefresh) {
                    this.expandAll = true;
                }
                let flg = false;
                let isComputeDays = false;// 是否自动计算天数，设置主任务暂时不用，设置子任务时需要
                if (this.configDetailObj.isAddSubTask) { // 增加子任务节点
                    this.$refs['configDetailObjForm'].validate(async (valid) => {
                        if (!valid) {
                            flg = true;
                            return false;
                        }
                    });
                    if (flg) { // 校验必填项
                        return;
                    }
                    if (!this.currentPItem.hasOwnProperty('children')) {
                        this.currentPItem.children = [];
                    }
                    this.currentPItem.open = true;
                    if (this.configDetailObj.workingDays) {
                        this.currentPItem.workingDays = Number(this.configDetailObj.workingDays) + Number(this.currentPItem.workingDays);
                    }
                    this.configDetailObj.opMode = 0;
                    this.currentPItem.children.push(this.configDetailObj);
                    await this.$refs.treeTableDragRef.onTreeDataChange(this.treeDatas);
                    this.expandAll = true;
                }
                if (this.configDetailObj.pId !== 0) { // 设置子任务
                    isComputeDays = true;
                }
                let treeDatas = this.$refs.treeTableDragRef.getCurrentTreeData();
                if (isComputeDays || isRefresh) {
                    //  if (!this.configDetailObj.isAddSubTask || isRefresh) {
                    // if (isRefresh) {
                    // setTimeout(() => {
                    await this.$refs.treeTableDragRef._resetData(treeDatas);
                    // }, 0);
                    // let dVal = this.configDetailObj.workingDays - this.oldConfigDetailObj.workingDays;// 得到当前任务天数的变化值(可能为负数)
                    // this.sumParentDays(treeDatas, dVal);
                    await this.sumParentDays(treeDatas);// 重新计算日期天数
                    this.sumFisrtLevel(treeDatas);
                }

                if (this.isInstance && this.$refs.processSliderRef && !isRefresh) {
                    this.configDetailObj.processVal = this.$refs.processSliderRef.getCurrentProcessVal();
                }
                let isBatchUpdateDate = false;
                // if ((this.isInstance && treeDatas.length > 0 && treeDatas[0].taskId === this.configDetailObj.taskId) || isRefresh) {
                // if ((this.isInstance && treeDatas.length > 0) || isRefresh) {
                if (this.isInstance && treeDatas.length > 0 && isRefresh) {
                    isBatchUpdateDate = true;
                    if (isEmpty(treeDatas[0].planStartTime)) {
                        this.$message({message: '请输入第一个任务的计划开始时间', type: 'warning'});
                        return;
                    }
                }
                // console.log(isBatchUpdateDate);
                this.taskSumTotalDays = 0;
                this.sumChildrenDays(treeDatas, treeDatas[0].planStartTime, isBatchUpdateDate, isNotCascade);
                if (isBatchUpdateDate) {
                    this.timeconfig.planFinalEndTime = treeDatas[treeDatas.length - 1].planEndTime;
                }
                this.treeDatas = cloneDeep(treeDatas);

                this.$refs.treeTableDragRef._resetExpandAll(this.expandAll);
                await this.$refs.treeTableDragRef._resetData(this.treeDatas);
                this.timeconfig.planTotalDays = this.taskSumTotalDays;
                if (this.isInstance && (this.ifConfigTask || (this.configDetailObj.pId && this.configDetailObj.pId !== 0 && this.configDetailObj.assigneeId === this.loginUserId))) {
                    // 进行最后保存
                    await this.handleTimeconfigFormSave();
                }
                this.isShowTaskTimeDialog = false;
            },
            sumChildrenDays (arr, lastEndTime, isBatchUpdateDate, isNotCascade) { // 计算树节点的开始与结束日期
                let innerLastEndTime = lastEndTime;
                let isFirst = true;
                for (let item of arr) {
                    if (item.pId === 0) {
                        this.taskSumTotalDays = Number(this.taskSumTotalDays) + Number(item.workingDays);
                    }
                    if (isBatchUpdateDate) { // 是否批量替换
                        // console.log(item.workingDays);
                        if (isNotCascade && item.planStartTime) { // 是否级联替换
                            let t1 = dateFormat(innerLastEndTime, 'yyyy-MM-dd');
                            let t2 = dateFormat(item.planStartTime, 'yyyy-MM-dd');
                            if (t1 <= t2) { // 如果上一个时间小于当前任务时间，以当前时间任务时间为准
                                innerLastEndTime = item.planStartTime;
                            } else {
                                isNotCascade = false;
                            }
                        }
                        if (item.workingDays === 0) {
                            item.planStartTime = innerLastEndTime;
                            item.planEndTime = innerLastEndTime;
                        } else {
                            if (innerLastEndTime !== '') {
                                if (!(isNotCascade && item.planStartTime)) { // 是否级联替换
                                    item.planStartTime = this.addDates(innerLastEndTime, isFirst ? 0 : 1);
                                }
                                if (isFirst) {
                                    isFirst = false;
                                }
                            }
                            if (item.planStartTime !== '') {
                            // item.planEndTime = this.addDateHours(item.planStartTime, Number(item.workingDays));
                                item.planEndTime = this.addDates(item.planStartTime, Number(item.workingDays) - 1);
                                innerLastEndTime = item.planEndTime;
                            }
                        }

                        if (item.children) {
                            this.sumChildrenDays(item.children, item.planStartTime, isBatchUpdateDate, isNotCascade);
                        }
                    } else {
                        innerLastEndTime = '';
                    }
                }
            },
            // sumParentDays (arr, dVal) { // 计算树节点的父节点累计工作时长
            //     for (let item of arr) {
            //         if (item.workingDays && item.id === this.configDetailObj.id) {
            //             if (item.pItem) {
            //                 // item.pItem.workingDays = Number(item.pItem.workingDays) + Number(dVal);
            //                 this.setParentDays(item.pItem, dVal);
            //             }
            //         }
            //         if (item.children) {
            //             this.sumParentDays(item.children, dVal);
            //         }
            //     }
            // },
            async sumParentDays (arr) { // 计算树节点的父节点累计工作时长
                let isFirst = true;
                for (let item of arr) {
                    if (item.children) {
                        if (isFirst) {
                            isFirst = false;
                        }
                        this.sumParentDays(item.children);
                    } else if (item.pItem) {
                        if (isFirst) {
                            item.pItem.isFirst = true;
                            isFirst = false;
                        } else {
                            item.pItem.isFirst = false;
                        }
                        this.setParentDays(item.pItem, item.workingDays);
                    }
                }
            },
            setParentDays (item, dVal) {
                if (item.isFirst) {
                    item.workingDays = Number(dVal);
                } else {
                    item.workingDays = Number(item.workingDays) + Number(dVal);
                }
                if (item.pItem) {
                    if (item.pItem.pId === 0) {
                        return;
                    }
                    if (item.pItem.pId === 0 && item.pItem.isFirst) {
                        item.pItem.isFirst = false;
                    } else {
                        item.pItem.isFirst = true;
                    }
                    this.setParentDays(item.pItem, item.workingDays);
                }
            },
            sumFisrtLevel (arr) {
                for (let item of arr) {
                    let totalDays = 0;
                    if (!isEmpty(item.children)) {
                        for (let subItem of item.children) {
                            totalDays = Number(totalDays) + Number(subItem.workingDays);
                        }
                        item.workingDays = totalDays;
                    }
                }
            },
            initTotalDays () {
                this.taskSumTotalDays = 0;
                let treeDatas = this.$refs.treeTableDragRef.getCurrentTreeData();
                for (let item of treeDatas) {
                    if (item.workingDays) {
                        this.taskSumTotalDays = Number(this.taskSumTotalDays) + Number(item.workingDays);
                    }
                }
            },
            addDateHours (sTime, hoursNum) { // hoursNum 小时数
                let tt = sTime;
                let time = new Date(tt);
                time.setHours(time.getHours() + hoursNum);
                time = new Date(time);
                let transTime = time.getFullYear() + '-' + this.appendZero((time.getMonth() + 1)) + '-' + this.appendZero(time.getDate()) + ' ' + this.appendZero(time.getHours()) + ':' + this.appendZero(time.getMinutes()) + ':' + this.appendZero(time.getSeconds());
                return transTime;
            },
            addDates (sTime, daysNum) { // daysNum 天数
                let tt = sTime;
                let time = new Date(tt);
                time.setHours(time.getHours() + daysNum * 24);
                time = new Date(time);
                let transTime = time.getFullYear() + '-' + this.appendZero((time.getMonth() + 1)) + '-' + this.appendZero(time.getDate());
                return transTime;
            },
            appendZero (source) {
                if (source < 10) {
                    return '0' + source;
                } else {
                    return source;
                }
            },
            handleFullScreen () {
                this.$emit('handleFullScreenForTime');
            },
            chooseUser () {
                setTimeout(() => { // 初始化
                    this.$refs.userOrgPop._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            selectTrigger (selected) {
                this.configDetailObj.assigneeId = selected.selectedUserIds;
                this.configDetailObj.assigneeName = selected.selectedUserNames;
            },
            treeDataChange (list) {
                this.treeDatas = list;
            },
            async changeSwitch () {
                this.$refs.treeTableDragRef._resetExpandAll(this.expandAll);
                this.loadTimer = new Date().getTime();
                // setTimeout(() => {
                await this.$refs.treeTableDragRef._resetData(this.treeDatas);
                // }, 0);
            },
            changeExpandStatus (arr) { // 计算树节点的开始与结束日期
                for (let item of arr) {
                    item.open = this.expandAll;
                    if (item.children) {
                        this.changeExpandStatus(item.children);
                    }
                }
            },
			      async exportTimeConfigDetailToExcel () {
                let url = `${API_PROCESS_TIME_CONFIG_DETAIL_TO_EXCEL}`;
                url = url.replace(':processInstanceId', this.instancesInfo.id).replace(':templateId', this.timeconfig.id);
                this.download(url);
            },
            download (url) {
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            async handleNavViewTimeGantt () {
                // let timeGanttInfo = await getPlanTimeGantt(this.instancesInfo.id);
                this.loadTimer = new Date().getTime();
                this.isShowTimeGantt = true;
                // 调用子组件方法
                setTimeout(() => { // 默认回显值
                    // this.$refs.timeGannt._setDefault(timeGanttInfo);
                    this.$refs.timeConfigGantt.initPage(this.instancesInfo.id);
                }, 0);
                // tooltip出不来，改为跳页方式
                // this.navTimeConfigGantt(this.instancesInfo.id);
            },
            async handelSetMainTask () {
                if (this.configDetailObj.taskStatus === 2) {
                    this.$message({
                        message: '不能干预配置已完成的任务节点!',
                        type: 'warning',
                        duration: 2000
                    });
                    return false;
                }

                // console.log(row);
                let taskId = this.configDetailObj.taskId;
                let taskName = this.configDetailObj.label;
                let processServiceId = this.instancesInfo.processServiceId;
                let deploymentId = this.instancesInfo.deploymentId;
                // console.log(this.instancesInfo);
                if (taskId) {
                    this.loadTimer = new Date().getTime();
                    let taskData = await getProcessServiceInstanceConfig(processServiceId, deploymentId, this.instancesInfo.id, taskId);
                    this.taskData = defaultsDeep(taskData, {
                        taskId: taskId,
                        taskName: taskName,
                        processServiceId: processServiceId,
                        deploymentId: deploymentId
                    }, defaultElementData);
                    this.taskTile = '【' + this.instancesInfo.name + '】: ' + taskData.taskName;
                    this.taskData.executor.isInitconfig = false;
                    this.taskData.processInstanceId = this.instancesInfo.id;
                    this.taskData.status = this.configDetailObj.taskStatus;
                    this.taskData.taskInstanceId = this.configDetailObj.taskInstanceId;
                    this.isShowEleEditor = true;
                    this.isShowSaveBtn = true;
                }
            },
            hideMainSaveBtn (flg) {
                this.isShowSaveBtn = flg;
            },
            async handleSaveConfig () {
                if (this.taskData.nodeInfo.isApproval === 1 && isEmpty(this.taskData.nodeInfo.approvalTemplateList)) {
                    this.$message({message: '当前任务为审批节点，请选择审批流模板！', type: 'warning'});
                    return;
                }
                if (this.taskData.nodeInfo.isSubProcess === 1 && isEmpty(this.taskData.nodeInfo.subProcesslTemplateList)) {
                    this.$message({message: '当前任务为业务流节点，请选择业务流模板！', type: 'warning'});
                    return;
                }
                if (this.taskData.executor.modeType === 2) { // 会签任务
                    // 校验会签人员是否存在
                    if (isEmpty(this.taskData.executor.countersignUsers)) {
                        this.$message({message: '当前会签节点未配置负责人，请配置后再保存', type: 'warning'});
                        return false;
                    }
                }
                this.$confirm(`您确定要修改当前任务配置吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    // 解决未知错误
                    // console.log(this.taskData.nodeInfo.approvalTemplateList);
                    // 转换showAllMyApprovals的值Integer为Boolean
                    if (this.taskData.nodeInfo.approvalTemplateList && this.taskData.nodeInfo.approvalTemplateList.length > 0) {
                        this.taskData.nodeInfo.approvalTemplateList.forEach(element => {
                            element.showAllMyApprovals = (element.showAllMyApprovals > 0);
                        });
                    }

                    await interveneProcessTaskConfig(this.taskData);
                    loading.close();
                    // this.$emit('refreshProcessList', true);
                    this.isShowEleEditor = false;
                    this.isShowTaskTimeDialog = false;
                    this.$emit('initTimeConig');
                }).catch(() => {});
            },
            handleTimeTemplateForms () {
                this.timeTemplateInstanceId = this.timeconfig.id;
                this.isShowTimeTemplateInstanceFormsDialog = true;
            }
        }
    };
</script>

<style lang="less">
    .timeconfig-detail {
        width: 100%;
        margin-top: -1%;
        margin-bottom: -2%;
        .timeconfig-form {
            // width: 700px;
        }
    }
   .task-edit-dialog {
        width: 800px;
        min-width: 600px;
        // max-width: 1200px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/TimeConfig/TimeConfigDetail/TimeConfigDetail.vue